export default __webpack_public_path__ + "static/media/vegetarian.e68e3b92.svg";